import { render, staticRenderFns } from "./TechPage.vue?vue&type=template&id=27d94575&scoped=true"
import script from "./TechPage.vue?vue&type=script&lang=js"
export * from "./TechPage.vue?vue&type=script&lang=js"
import style0 from "./TechPage.vue?vue&type=style&index=0&id=27d94575&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d94575",
  null
  
)

export default component.exports